namespace Roodik.Game
{
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	import ViewBase = Roodik.Core.ViewBase;

	export class GameOverPanel extends ViewBase
	{
		public static readonly PLAY_AGAIN: string = "GameOver.PlayAgain";
		public events: PIXI.utils.EventEmitter;
		private _playAgain : SimpleButton;
		private _tweenHide:Tween;
		private _tweenShow:Tween;
		private _message:PIXI.Text;

		constructor()
		{
			super("GameEndPanel");

			this.events = new PIXI.utils.EventEmitter();

			this._playAgain = new SimpleButton(this.childByName("PlayAgain").display,
			"Ещё раз", {
				fontFamily: 'Arial',
				fontSize: 45,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: '#ffffff',//['#ffffff', '#4a1850'], // gradient
				/*stroke: '#4a1850',*/
				/*strokeThickness: 5,
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 4,
				dropShadowAngle: Math.PI / 6,
				dropShadowDistance: 6,*/
				wordWrap: true,
				wordWrapWidth: 440,
				padding:20
			});
			this._playAgain.events.on(SimpleButton.CLICKED, this.onPlayAgain.bind(this));

			this._message = new PIXI.Text("Будь внимательней!",
			{
				fontFamily: 'Arial',
				fontSize: 40,
				/*fontStyle: 'italic',*/
				fontWeight: 'bold',
				fill: ['#ffffff', '#F48024'],//['#ffffff', '#00ff99'], // gradient
				stroke: '#4a1850',
				strokeThickness: 3,
				padding:20
			});
			this._message.x = -this._message.width * 0.5;
			this._message.y = -this._message.height * 0.5;
			this.addChild(this._message);

			this.alpha = 0;
			this.y = 100;
			this.show();
		}

		private show()
		{
			let properties = {alpha:0,y:this.y};
			this._tweenShow = new Tween(properties)
			.to({alpha: 1, y:0}, 100)
			.easing(Easing.Linear.None)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(function () {
				this._tweenShow.stop();
			}.bind(this))
			.start();
		}

		private onPlayAgain()
		{
			let properties = {alpha:this.alpha,y:this.y};
			this._tweenHide = new Tween(properties)
			.to({y: -100,alpha:0}, 100)
			.easing(Easing.Linear.None)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(function () {
				this._tweenHide.stop();
				this.events.emit(GameOverPanel.PLAY_AGAIN);
			}.bind(this))
			.start();
		}

		public destroy()
		{
			this._message.destroy();
			this.removeChild(this._message);

			this._playAgain.events.off(SimpleButton.CLICKED, this.onPlayAgain.bind(this));
			this.events = null;
			
			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/GameOverPanel.ts